// Rotalar, rota editörü, sihirbaz, versiyonlar ve karşılaştırma, talepler, ısı haritası (C09–C12, C16–C20): Control
// yönlendirmeleri (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const RouteList = load(() => import('./RouteList'), 'RouteList');
const RouteDetail = load(() => import('./RouteDetail'), 'RouteDetail');
const RouteEditor = load(() => import('./RouteEditor'), 'RouteEditor');
const RouteWizard = load(() => import('./RouteWizard'), 'RouteWizard');
const RouteVersions = load(() => import('./RouteVersions'), 'RouteVersions');
const VersionCompare = load(() => import('./VersionCompare'), 'VersionCompare');
const RequestInbox = load(() => import('./RequestInbox'), 'RequestInbox');
const RequestDetail = load(() => import('./RequestDetail'), 'RequestDetail');
const DemandHeatmap = load(() => import('./DemandHeatmap'), 'DemandHeatmap');

export const planningRoutes = (
  <>
    <Route path="rotalar" element={guard(RouteList, 'routes')} />
    <Route path="rotalar/yeni" element={guard(RouteWizard, 'routes', { action: 'edit' })} />
    <Route path="rotalar/:id" element={guard(RouteDetail, 'routes')} />
    <Route path="rotalar/:id/duzenle" element={guard(RouteEditor, 'routes', { action: 'edit' })} />
    <Route path="rotalar/:id/surumler" element={guard(RouteVersions, 'routes')} />
    <Route path="rotalar/:id/surumler/karsilastir" element={guard(VersionCompare, 'routes')} />
    <Route path="talepler" element={guard(RequestInbox, 'requests')} />
    <Route path="talepler/isi-haritasi" element={guard(DemandHeatmap, 'requests', { flag: 'AI_OPTIMIZATION' })} />
    <Route path="talepler/:id" element={guard(RequestDetail, 'requests')} />
  </>
);
